import { useDispatch } from 'react-redux';

export const UserLogOut = () => {
  const dispatch = useDispatch();

  dispatch({ type: 'LOGOUT' }); // TODO

  return null;
};
